export const cleanupContextualTools = (contextualTools: any) => {
  return contextualTools.map((tool) => {
    if (tool.name === 'Shared with' && tool.lines) {
      tool.lines = tool.lines.map((line) => {
        let updatedLabel = line.label;
        updatedLabel = updatedLabel?.replace(/\s*\[by.*?\]/, '');
        updatedLabel = updatedLabel?.replace(/\s*--\s*\[Creator\]/, '');

        return {
          ...line,
          label: updatedLabel?.trim(),
          description: line.description === 'OUser' ? 'User' : line.description
        };
      });
    }
    return tool;
  });
};
